enum TypeApiWebhookAuthentication {
  NO_AUTH = 'NO_AUTH',
  TOKEN = 'TOKEN',
  BASIC = 'BASIC'
}

export default TypeApiWebhookAuthentication;
